export const highlightTextFragments: (text: string) => string = (text: string): string => {
  const changedText: string = text
    .replace(/\[c\:(?<color>[a-zA-Z]+)\]/g, '<span class=\"text-decoration-\$1\">')
    .replace(/\[\/c\]/g, '</span>');

  return changedText;
};
